// script loaded in snippets/product.liquid
// this appends (+£0.00) to the select true option if no price is present in parentheses
document.addEventListener('DOMContentLoaded', () => {
  const timeoutDuration = 10000; // 10 seconds
  const checkInterval = 200; // check every 200ms
  const startTime = Date.now();

  const intervalId = setInterval(() => {
    const select = document.querySelector('.loxa-select');

    if (select) {
      const trueOption = select.querySelector('option[value="true"]');

      if (trueOption) {
        const text = trueOption.textContent;

        // Check if there's already a price in parentheses (e.g., (+£10.99))
        const pricePattern = /\(\+£\d+\.\d{2}\)/;

        if (!pricePattern.test(text)) {
          trueOption.textContent += ' (+£0.00)';
        } 
      }

      clearInterval(intervalId);
    } else if (Date.now() - startTime >= timeoutDuration) {
      console.warn('Timeout: .loxa-select not found.');
      clearInterval(intervalId);
    }
  }, checkInterval);
});
